import * as CryptoJS from 'crypto-js';
import { OneOf } from '../util/util'


export interface TemporalCoordinate {
  time: number,
  start: number,
  end: number
}
export interface TemporalDataCoordinate extends TemporalCoordinate {
  duration: number,
  perpetual: boolean,
  since: boolean,
  until: boolean,
  moment: boolean
}


export interface SpatialCoordinate {
  lat: number,
  lng: number
  north: number,
  east: number,
  south: number,
  west: number
}
export interface SpatialDataCoordinate extends SpatialCoordinate{
  representsLocation: boolean,
  geometry?: any,
  holdsCoordinates: boolean
}


export interface DataItem extends SpatialDataCoordinate, TemporalDataCoordinate  {
  id: string,

  version?: number,
  domMap: { [key: string]: HTMLElement },
  properties: any,

  selected?: boolean,

  getDocument: () => any
}
export const compareByLocation = (dataItem0: SpatialCoordinate, dataItem1: SpatialCoordinate): number => {
  if (dataItem0 == undefined && dataItem1 == undefined) return 0;
  if (dataItem0 == undefined) return 1;
  if (dataItem1 == undefined) return -1;

  let lat0 = dataItem0.lat != undefined ? dataItem0.lat : dataItem0.north;
  let lat1 = dataItem1.lat != undefined ? dataItem1.lat : dataItem1.north;
  if (lat0 > lat1) { //datum 0 lies more north
    return -1;
  } else if (lat1 > lat0) { //datum 1 lies more north
    return 1;
  } else { //datum 0 and 1 have the same latitude
    let lng0 = dataItem0.lng != undefined ? dataItem0.lng : dataItem0.west;
    let lng1 = dataItem1.lng != undefined ? dataItem1.lng : dataItem1.west;

    if (lng0 < lng1) { //datum 0 lies more west
      return -1;
    } else if (lng1 < lng0) {//datum 1 lies more west
      return 1;
    } else { // datum 0 and 1 lie on the same position
      return 0;
    }
  }
}

export const compareByTime = (dataItem0: TemporalCoordinate, dataItem1: TemporalCoordinate): number => {
  if (dataItem0 == undefined && dataItem1 == undefined) return 0;
  if (dataItem0 == undefined) return 1;
  if (dataItem1 == undefined) return -1;


  if (dataItem0.start != undefined) {// dataItem0 represents a MOMENT, TIME RANGE
    // or FOREVER IN THE FUTURE
    if (dataItem1.start != undefined) {// dataItem1 represents a MOMENT, TIME
      // RANGE or FOREVER IN THE FUTURE
      return dataItem0.start - dataItem1.start; // compare startTimes
    } else {// dataItem1 represents ALL TIME or FOREVER IN THE PAST
      return 1;// dataItem1 precedes
    }
  } else if (dataItem0.end != undefined) {// dataItem0 represents FOREVER IN THE
    // PAST
    if (dataItem1.start != undefined) {// dataItem1 represents a MOMENT, TIME
      // RANGE or FOREVER IN THE FUTURE
      return -1;// dataItem0 precedes
    } else if (dataItem1.end != undefined) {// dataItem1 represents FOREVER IN
      // THE PAST
      return dataItem0.end - dataItem1.end; // compare endTimes
    } else {// dataItem1 represents ALL TIMES
      return -1;// dataItem0 precedes
    }
  } else {// dataItem0 represents ALL TIMES
    if (dataItem1.end != undefined) {// dataItem1 represents a TIMERANGE or
      // FOREVER IN THE PAST
      if (dataItem1.start != undefined) {// dataItem1 represents a TIMERANGE
        return -1;// dataItem0 precedes
      } else {// dataItem1 represents FOREVER IN THE PAST
        return 1;// dataItem1 precedes
      }
    } else if (dataItem1.start == undefined) {// dataItem1 represents ALL
      // TIMES
      return 0; // they are equal
    } else {// dataItem1 represents a MOMENT or FOREVER IN THE FUTURE
      return -1;// dataItem0 precedes
    }
  }
}
export const dataItemTemporalHash = (dataItem: DataItem) => {
  return CryptoJS.MD5(`${dataItem.id}_${dataItem.start}_${dataItem.end}`).toString(CryptoJS.enc.Hex);
}

export const dataItemSpatialHash = (dataItem: DataItem) => {
  return CryptoJS.MD5(`${dataItem.id}_${dataItem.lat !==undefined ? dataItem.lat : dataItem.north}_${dataItem.lng !==undefined ? dataItem.lng : dataItem.west}`).toString(CryptoJS.enc.Hex);
}

export const createElemSelector = (identifiers: string[]): string => {
  return `_${CryptoJS.MD5(identifiers.sort().join('#')).toString(CryptoJS.enc.Hex)}`;
}

export const temporalUnion = (tc0: TemporalDataCoordinate, tc1: TemporalDataCoordinate, padding: number): TemporalDataCoordinate => {
  let ps = padding;
  let pl = padding * 3;

  let s: number;
  let e: number;

  if (!tc0.perpetual) {
    if (!tc1.perpetual) {
      if (tc0.moment) {
        if (tc1.moment) {//M,M
          s = Math.min(tc0.start, tc1.start);
          e = Math.max(tc0.end, tc1.end);
          if (Math.abs(e - s) >= 1) {//apply some padding when the two moments are not the same
            s -= ps;
            e += ps;
          }
        } else if (tc1.until) {//M,U
          s = null;
          e = Math.max(tc0.end + ps, tc1.end);
        } else if (tc1.since) {//M,S
          s = Math.min(tc0.start - ps, tc1.start);
          e = null;
        } else {//M,R
          s = Math.min(tc0.start - ps, tc1.start);
          e = Math.max(tc0.end + ps, tc1.end);
        }
      } else if (tc0.until) {
        if (tc1.moment) {//U,M
          s = null;
          e = Math.max(tc0.end, tc1.end + ps);
        } else if (tc1.until) {//U,U
          s = null;
          e = Math.max(tc0.end, tc1.end);
        } else if (tc1.since) {//M,S
          s = Math.min(tc0.start - ps, tc1.start);
          e = null;
        } else {//U,R
          s = Math.min(tc0.end - pl, tc1.start);
          e = Math.max(tc0.end, tc1.end);
        }
      } else if (tc0.since) {
        if (tc1.moment) {//S,R
          s = Math.min(tc0.start, tc1.start);
          e = Math.max(tc0.start + pl, tc1.end);
        } else if (tc1.until) {//S,U
          s = Math.min(tc0.start, tc1.end - pl);
          e = Math.max(tc0.start + pl, tc1.end);
        } else if (tc1.since) {//S,S
          s = Math.min(tc0.start, tc1.start);
          e = null;
        } else {//S,R
          s = Math.min(tc0.start, tc1.start);
          e = Math.max(tc0.start + pl, tc1.end);
        }
      } else {
        if (tc1.moment) {//R,M
          s = Math.min(tc0.start, tc1.start - ps);
          e = Math.max(tc0.end, tc1.end + ps);
        } else if (tc1.until) {//R,U
          s = Math.min(tc0.start, tc1.end - pl);
          e = Math.max(tc0.end, tc1.end);
        } else if (tc1.since) {//R,S
          s = Math.min(tc0.start, tc1.start);
          e = Math.max(tc0.end, tc1.start + pl);
        } else {//R,R
          s = Math.min(tc0.start, tc1.start);
          e = Math.max(tc0.end, tc1.end);
        }
      }

      if (s != null && e != null) {
        e = Math.abs(e - s) < 1 ? s : e;
      }

      let union = {
        time: <number>undefined,
        start: s,
        end: e,
        duration: (s != null && e != null ? Math.abs(e - s) < 1 ? 0 : e - s : <number>null),
        perpetual: (s == null && e == null),
        moment: (s != null && e != null && Math.abs(e - s) < 1 ? true : false),
        since: (s != null && e == null),
        until: (s == null && e != null)
      }
      return union;
    } else {
      return tc0;
    }
  } else {
    return tc1;
  }

  return undefined;
}

export const spatialUnion = (sc0: SpatialDataCoordinate, sc1: SpatialDataCoordinate): SpatialDataCoordinate => {
  if (sc0 && sc0.holdsCoordinates) {
    if (sc1 && sc1.holdsCoordinates) {
      let n = Math.max(sc0.north, sc1.north);
      let e = Math.max(sc0.east, sc1.east);
      let s = Math.min(sc0.south, sc1.south);
      let w = Math.min(sc0.west, sc1.west);
      let union = {
        north: n,
        east: e,
        south: s,
        west: w,
        lat: ((n + s) / 2),//this will not work on date boundary
        lng: ((e + w) / 2),
        holdsCoordinates: true,
        representsLocation: ((Math.abs(s - n) < 0.00001) && (Math.abs(w - e) < 0.00001))
      };
      return union;
    } else {
      return sc0;
    }
  } else {
    return sc1;
  }
}